import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const SayilPalace = {
  id: '56',
  name: 'Sayil Palace',
  era: EraType.earlyRome,
  icon: 'sp',
  gameId: 'SayilPalace',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.FORTRESS | WonderKind.PALACE,
  kindMultiplier: 1,
  owner: WonderOwner.MAYA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.BASTION_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        2.5,
        3.2,
        3.7,
        4.2,
        4.5,  // 5
        4.9,
        5.2,
        5.4,
        5.7,
        5.9, // 10
        6.2,
        6.4,
        6.6,
        6.8,
        7.0, // 15
        7.1,
        7.3,
        7.5,
        7.6,
        7.8, // 20
        7.9,
        8.1,
        8.2,
        8.4,
        8.5, // 25
        8.6,
        8.8,
        8.9,
        9.0,
        9.1  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include mercenary commander.')
      ,
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(2).withKind(WonderKind.FORTRESS),
      effect: null,
    }
  ],
};

export default SayilPalace;
